import { render, staticRenderFns } from "./SingleMcaInformationTable.vue?vue&type=template&id=65074287&scoped=true&"
import script from "./SingleMcaInformationTable.vue?vue&type=script&lang=js&"
export * from "./SingleMcaInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleMcaInformationTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleMcaInformationTable.vue?vue&type=style&index=1&id=65074287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65074287",
  null
  
)

export default component.exports